import { Button } from "@intech/web-ui";
import { lighten } from "polished";
import styled, { css } from "styled-components";
import { IconProps } from ".";

const colors = {
  danger: css`
    color: ${props => lighten(0.1, props.theme.colors.red)};
  `,
  warning: css`
    color: ${props => lighten(0.1, props.theme.colors.yellow)};
  `,
  info: css`
    color: ${props => lighten(0.2, props.theme.colors.blue)};
  `,
  success: css`
    color: ${props => lighten(0.05, props.theme.colors.green)};
  `
}

export const Icon = styled.span<IconProps>`
  margin: 0 5px;
  ${props => colors[props.type]}
`;
